import { FC } from 'react';
import AlignCenter from './AlignCenter';
import AlignRight from './AlignRight';
import AlignLeft from './AlignLeft';
import Plus from './Plus';
import Minus from './Minus';
import ArrowLeft from './ArrowLeft';
import ArrowRight from './ArrowRight';

const icons: { [key: string]: any } = {
  AlignCenter,
  AlignRight,
  AlignLeft,
  Plus,
  Minus,
  ArrowLeft,
  ArrowRight,
};
interface iIcon {
  children: string;
}
const Icon: FC<iIcon> = ({ children }) => {
  const Icon = icons[children];
  if (Icon) return <Icon />;
  return <span>{children}</span>;
  // return children ?? <FeatherIcon icon={children} />;
};

export default Icon;
